import { env } from '@hb/NBridge/lib/h5';
import { UBT } from '@hb/tianqi/lib/ubt.h5';

/* eslint-disable import/prefer-default-export */
export const getFinalBuyPrice = (card) => {
  if (!card) {
    return '';
  }
  if (card.actualPrice && card.actualPrice.finalPrice) {
    return card.actualPrice.finalPrice;
  }
  return card.purchasePrice || '';
};

export const RESULT_PAGE_ENUMS = { PURCHASE: 1, UPGRADE: 2 };

export const PLATFORM_ALIMP = '1';
export const PLATFORM_APP = '2';
export const PLATFORM_H5 = '3';
export const CARD_MODULE = {
  market_sale: 'market_sale',
  market_coupon: 'market_coupon',
  market_card: 'market_card',
  market_banner: 'market_banner',
};
export const CARD_MODULE_B = {
  market_sale: 'market_sale', // 大促模块
  market_bike_header: 'market_bike_header', // 单车标题
  market_bike_coupon: 'market_bike_coupon', // 单车券
  market_bike_card: 'market_bike_card', // 单车卡
  market_evBike_header: 'market_evBike_header', // 助力车标题
  market_evBike_coupon: 'market_evBike_coupon', // 助力车券
  market_evBike_card: 'market_evBike_card', // 助力车卡
  market_banner: 'market_banner',
};


export const platform = () => {
  if (env.isAliMP || env.isAliMPMonitor) {
    return PLATFORM_ALIMP;
  }
  if (env.isEasyBikeApp) {
    return PLATFORM_APP;
  }
  return PLATFORM_H5;
};

export const cardPageTQ = () => {
  const port = platform();
  if (port === PLATFORM_APP) {
    return '0';
  }
  if (port === PLATFORM_ALIMP) {
    return '1';
  }
  return '2';
};

export const sendTQ = (pageId, { ...businessInfo }, categoryId = 'platform') => {
  UBT.pageView({
    pageId,
    categoryId,
    businessInfo: {
      ...businessInfo,
    },
  });
};

const port = null;
export function getPageBPort() {
  if (port) {
    return port;
  }
  if (env.isEasyBikeApp) {
    return '0';
  }
  if (env.isAliMP || env.isAliMPMonitor) {
    return '1';
  }
  return '2';
}
